import styled from 'styled-components'

const Line = styled.div`
  display: flex;
  align-items: center;
  background-color: #b19961;
  width: 100%;
  height: 8px;
  flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
  margin: ${props => props.marg};
`;

export default Line